import { useContext, createContext, useState, useEffect } from "react";
import { fetchUserProfile } from "../services/dataService";
import { fetchUserRole } from "../services/user.services";
import { useNavigate } from "react-router-dom";
import i18n from "../i18n";

export const LoginContext = createContext();

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

export const LoginProvider = ({ children }) => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [loggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [mobileNumber, setMobileNumber] = useState("");
  const [profilePicture, setProfilePicture] = useState("");
  const [role, setRole] = useState();
  const [loading, setLoading] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [checkedLogin,setCheckedLogin]=useState(false);

  // // ✅ Get token from cookie on load
  useEffect(() => {
    const cookieToken = getCookie("token");
    if (cookieToken && window.AndroidBridge) {
      login(cookieToken);
    } else if (!token) {
      setCheckedLogin(true);
    }
  }, []);

  // Fetch user data whenever token changes
  useEffect(() => {
    const getUserData = async () => {
      if (!token) {
        setIsLoggedIn(false);
        setCheckedLogin(true);
        return;
      }
      try {
        setLoading(true);
        const [data, roleData] = await Promise.all([
          fetchUserProfile(token),
          fetchUserRole(),
        ]);
        setRole(roleData);
        setUserName(data.name);
        setProfilePicture(data.image);
        setMobileNumber(data.mobile_number);
        setAdmin(roleData === "admin");
        if (["en", "hi"].includes(data.preferred_language)) {
          await i18n.changeLanguage(data.preferred_language);
          localStorage.setItem("i18nextLng", data.preferred_language);
          document.documentElement.lang = data.preferred_language;
        }
        setIsLoggedIn(true);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setToken(null);
        setIsLoggedIn(false);
        setRole(null);
        setAdmin(false);
        localStorage.removeItem("token");
      } finally {
        setLoading(false);
        setCheckedLogin(true);
      }
    };
    getUserData();
  }, [token]);

  const login = (newToken) => {
    setToken(newToken);
    setIsLoggedIn(true);
    localStorage.setItem("token", newToken);
    setCheckedLogin(true);
  };

  const logout = () => {
    setToken(null);
    setIsLoggedIn(false);
    setUserName("");
    setProfilePicture("");
    setMobileNumber("");
    setRole(null);
    setAdmin(false);
    localStorage.removeItem("token");
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    if (window.AndroidBridge && typeof window.AndroidBridge.logout === "function") {
      window.AndroidBridge.logout();
      setCheckedLogin(false);
    }
    navigate("/login");
  };

  return (
    <LoginContext.Provider
      value={{
        userName,
        role,
        loading,
        loggedIn,
        token,
        mobileNumber,
        profilePicture,
        login,
        logout,
        admin,
        checkedLogin
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => useContext(LoginContext);
